let locale = window.Shopify.locale;

$(document).ready(function () {
  function openEarnHistory(openlink) {
    if (locale != 'th'){
    window.location.href = "/" + locale + "/pages/earn-history";
  }
    else {
      window.location.href = "/pages/earn-history";
    }

  }
  $(".menu-icon").click(function () {
    openEarnHistory($(this));
  });
});
$(document).ready(function () {
  var modal = $(".modal");
  var overlay = $(".overlay");
  // var close = $(".close-registration_reward");
  // var popup_reward = $(".popup-reward-modal");

  const closeModal = function () {
    modal.addClass("hidden");
    overlay.addClass("hidden");
    // popup_reward.addClass("hidden");
  };
  overlay.click(closeModal);
  // close.click(closeModal);
  // $(".cancel-popup-button").click(closeModal);

  function openPopup(popuplink) {
    $(".overlay,.modal").removeClass("hidden");
  }

  // $(".challenge-btn").click(function () {
  //   openPopup($(this));
  // });
});

function earnViaLine() {
  $(".overlay,.modal").removeClass("hidden");
}

function earnOnLoad(customer_id, cus_phone) {
  static_data = {
    "get": "Get",
    "expire_in": "Expire in",
    "earn_via_line": "Earn via Line",
  }
  if (locale == 'th'){
    static_data = {
      "get": "รับ",
      "expire_in": "หมดอายุใน",
      "earn_via_line": "รับคะแนนผ่านไลน์",
    }
  }

  var settings = {
    url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
      client: "magenest",
    }),
  };

  $.ajax(settings).done(function (response) {
    supara_token = response.data.token;
    var ajax_customer = {
      url:
        "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/get?mobile=" +
        parseInt(cus_phone) +
        "&source=INSTORE",
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + response.data.token,
      },
    };

    $.ajax(ajax_customer).done(function (cus) {
      try {
        var rate =
            (parseFloat(cus.data.customers[0].points_summaries[0].total_available_points) * 100) /
          (parseFloat(cus.data.customers[0].points_summaries[0].total_available_points) +
            parseFloat(
              cus.data.customers[0].tier_info.min_purchase_value_required
            ));
        document.getElementById("point-rate").style.width =
          rate.toString() + "%";
      } catch {
        var rate = 0;
      }
      document.getElementById("point-rate").style.width = rate.toString() + "%";
      document.getElementById("current_rank").innerText =
        cus.data.customers[0].current_slab;
      if (cus.data.customers[0].current_slab == "Platinum") {
        $(".all-figure").css("display", "none");
        $(".next_tier_div").css("display", "none");
      } else {
        document.getElementById("next_rank").innerText =
          cus.data.customers[0].points_summaries[0].nextSlab;
        document.getElementById("point_to_next_tier").innerText =
          cus.data.customers[0].tier_info.min_purchase_value_required;
      }
      document.getElementById("avatar_loyalty_point2").innerText =
        cus.data.customers[0].points_summaries[0].total_available_points;
    });

    var ajax_challenges = {
      url:
        "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/challenges?mobile=" +
        parseInt(cus_phone),
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + response.data.token,
      },
    };

    $.ajax(ajax_challenges).done(function (response) {
      challenges = response.data.customers[0].challenges.points;
      var challenges_list_html = "";
      for (i = 0; i < challenges.length; i++) {
        challenge = challenges[i];
        challenges_list_html =
          challenges_list_html +
          '<div class="earn-challenge-div"><div class="earn-img-div"><img class="earn-challenge" src="https://cdn.shopify.com/s/files/1/0691/9100/8576/files/1_0fa7cc5f-6673-4c36-aa42-7f2efc084f7f.png?v=1708657475"></div><div class="challenge-label-div"><div class="challenge-title">' +
          challenge.name +
          '</div><div class="challenge-reward">'+static_data.get+' <img src="https://cdn.shopify.com/s/files/1/0631/7755/6173/files/GQ-Coin.png?v=1715157282" class="gqcoin_icon"><span class="challenge-reward-poin">' +
          " " +
          challenge.points +
          '</span></div><div class="challenge-expire">' +
          static_data.expire_in +': ' +
          challenge.expiry_date +
          '</div><button class="challenge-btn" onclick="earnViaLine()">'+static_data.earn_via_line+'</button></div></div>';
      }
      document.getElementById("challenges_list_html").innerHTML =
        challenges_list_html;
    });
  });
}
